import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {BackTop, Breadcrumb, Button, Card, Collapse, Descriptions, Divider, Skeleton, Space, Tag, Timeline} from "antd";
import moment from "moment";
import DB_Log from "../../../database/development/log";
import ReactJson from 'react-json-view'
import {CheckCircleOutlined, ExclamationCircleOutlined, QuestionCircleOutlined,} from "@ant-design/icons";
import BackButton from "../../tech/back_button";


const EditLog = () => {
    const {log_id} = useParams()

    const {token, setToken} = useContext(Context);
    const {t,} = useTranslation();
    const {getLog, getRequest} = DB_Log(token)
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);
    const [data, setData] = useState({});
    const [errors, setErrors] = useState([]);
    const [warnings, setWarnings] = useState([]);
    const [info, setInfo] = useState([]);
    const [endText, setEndText] = useState(t('end_import_completed'));
    const [endColor, setEndColor] = useState('green');
    const [endDot, setEndDot] = useState(<CheckCircleOutlined/>);
    const [pending, setPending] = useState(null)
    const [tag, setTag] = useState(0);
    const [request, setRequest] = useState('')


    useEffect(() => {
        window.scroll(0, 0)

        if (log_id != null) {
            getLog(log_id)
                .then(log => {
                    setData(log.data)

                    if (log.data.processing === 1) {
                        setTag(1)
                    } else if (log.data.errors_count > 0 || log.data.status === 406 || log.data.status === 403) {
                        setTag(2)
                    } else if (log.data.warnings_count > 0) {
                        setTag(3)
                    } else {
                        setTag(4)
                    }

                    setErrors(log.data.errors)
                    setWarnings(log.data.warnings)
                    setInfo(log.data.info)
                    setWait(false)
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })


        }

    }, [])


    useEffect(() => {
        if (data.type != null) {
            getRequest(data.type, log_id)
                .then(res => {
                    setRequest(res.data)
                })
        }
    }, [data])

    useEffect(() => {
        EndTimeLine()
    }, [errors, warnings])

    const EndTimeLine = () => {
        if (data.processing === 1) {
            setPending(t('processing'))
        } else if (data.errors_count > 0 && data.warnings_count > 0) {
            setEndText(t('end_import_errors_warnings'))
            setEndDot(<ExclamationCircleOutlined/>)
            setEndColor('red')
        } else if (data.errors_count > 0 || tag === 2) {
            setEndText(t('end_import_errors'))
            setEndDot(<ExclamationCircleOutlined/>)
            setEndColor('red')

        } else if (data.warnings_count > 0) {
            setEndText(t('end_import_warnings'))
            setEndDot(<QuestionCircleOutlined/>)
            setEndColor('orange')
        }


    }

    const RequestInfo = () => {
        return (
            <>
                {/*<Collapse>*/}
                {/*    <Collapse.Panel header={t('request_info')} key={1}>*/}
                {t('request_head_information')}
                <pre>
                    {JSON.stringify(request.info, null, 2)}
                </pre>
                {/*    </Collapse.Panel>*/}
                {/*</Collapse>*/}
            </>
        )
    }

    // const Request = () => {
    //     try {
    //         return (
    //             <>
    //                 <Collapse>
    //                     <Collapse.Panel header={t('request')} key={1}>
    //                 <pre>
    //                     {JSON.stringify(JSON.parse(request.body), null, 2)}
    //                 </pre>
    //                     </Collapse.Panel>
    //                 </Collapse>
    //             </>
    //         )
    //     } catch (e) {
    //         return (
    //             <Collapse>
    //                 <Collapse.Panel header={t('request')} key={1}>
    //                     {request.body == null ? null : request.body.replace('/\n', '')}
    //                 </Collapse.Panel>
    //             </Collapse>
    //         )
    //     }
    // }

    const Tag_status = () => {
        if (tag === 1) {
            return (<Tag color="processing">{t('processing')}</Tag>)
        } else if (tag === 2) {
            return (<Tag color="error">{t('error')}</Tag>)
        } else if (tag === 3) {
            return (<Tag color="warning">{t('warning')}</Tag>)
        } else {
            return (<Tag color="success">{t('success')}</Tag>)
        }
    }

    const showRequest = () => {
        let blob = new Blob(["No data"], {  encoding:"UTF-8", type: 'text/html;charset=UTF-8'});
        try {
            const html = JSON.stringify(JSON.parse(request.body), null, 2)
            blob = new Blob([html], { encoding:"UTF-8", type: 'application/json;charset=UTF-8'});
        } catch (e) {
            try {
                let html = `<html><head></head><body>${request.body.replace("\n", "").replace("\r", "").replace("\t", "")}</body></html>`
                blob = new Blob([html], {encoding: "UTF-8", type: 'text/html;charset=UTF-8'});
            } catch (e) {}
        }
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
    }

    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('log')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>
                    </Space>
                </Space>

                <Card
                    extra={[
                            <Tag_status key={1}/>
                        ]}
                >
                    <Skeleton loading={wait} active>
                        <Descriptions>
                            <Descriptions.Item label={t('date')}>
                                <span
                                    style={{fontFamily: 'Montserrat-Medium'}}>{moment.utc(data.date).format("DD.MM.YYYY HH:mm:ss")}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('branch')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.branch}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('type')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{t(data.type)}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('status_code')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.status}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('warnings')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.warnings_count}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('errors')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.errors_count}</span>
                            </Descriptions.Item>

                        </Descriptions>

                        <Divider/>
                    </Skeleton>
                    <Skeleton loading={wait} active>
                        <Timeline pending={pending}>
                            <Timeline.Item color="green">{t('start_import')}</Timeline.Item>
                            {errors.map((e, i) =>
                                <Timeline.Item color="red" key={i}>
                                    <p>{t(e.message)}</p>
                                    {e.source != null ?
                                        <Collapse ghost>
                                            <Collapse.Panel header={t('more')} key={i}>
                                                <ReactJson src={JSON.parse(e.source)} name={null}
                                                           displayDataTypes={false}
                                                           displayObjectSize={false}
                                                           enableClipboard={false}/>
                                            </Collapse.Panel>
                                        </Collapse>
                                        : null
                                    }
                                </Timeline.Item>
                            )}
                            {warnings.map((w, i) =>
                                <Timeline.Item color="orange" key={i}>
                                    <p>{t(w.message)}</p>
                                    <Collapse ghost>
                                        <Collapse.Panel header={t('more')} key={i}>
                                            <ReactJson src={JSON.parse(w.source)} name={null}
                                                       displayDataTypes={false}
                                                       displayObjectSize={false} enableClipboard={false}/>
                                        </Collapse.Panel>
                                    </Collapse>
                                </Timeline.Item>
                            )}
                            {info.map((w, i) =>
                                <Timeline.Item color="gray" key={i}>
                                    <p>{t(w.message)}</p>
                                    <Collapse ghost>
                                        <Collapse.Panel header={t('more')} key={i}>
                                            <ReactJson src={JSON.parse(w.source)} name={null}
                                                       displayDataTypes={false}
                                                       displayObjectSize={false} enableClipboard={false}/>
                                        </Collapse.Panel>
                                    </Collapse>
                                </Timeline.Item>
                            )}
                            {data.processing === 1 ? null :
                                <Timeline.Item color={endColor} dot={endDot}>{endText}</Timeline.Item>}
                        </Timeline>
                    </Skeleton>
                    <Skeleton loading={wait} active>
                        <RequestInfo/>
                        <Button style={{marginTop:'10pt'}} type={'primary'} onClick={showRequest}>{t('request')}</Button>
                        {/*<Request/>*/}
                    </Skeleton>
                </Card>

                <BackTop />
            </div>
            <Outlet/>
        </>
    )
}

export default EditLog;